
<template>
    <div>
        <el-row :gutter="20">
            <el-col v-show="collapse == 0" :span="3">
                <div :style="{ height: screenHeight + 'px', position: 'relative', background: '#e0f2f1' }">
                    <div v-for="item in surgeries" :key="item.id" class="surgery-patient-list" style="padding-top: 10px" :class="{ surgeryActive: item.id == surgeryId }">
                        <el-row>
                            <div class="cursor-pointer" @click="ReloadDocument(item.id)">
                                <el-col :span="24" class="padding5 padding-none-v align-left" :title="titleLabel(item)">
                                    <div class="ellipsis">
                                        <b>
                                            {{ `${item.patient_name}(${item.sex || '--'}` }}
                                            <i style="color: red !important">/</i>{{ ` ${item.age || '--'} ` }} <i style="color: red !important">/</i>{{ ` ${item.bed_no || '--'}床 ` }}
                                            <i style="color: red !important">/</i>{{ ` ${item.visit_no})` }}
                                        </b>
                                    </div>
                                    <div>
                                        <b class="ellipsis">{{ item.surgeries }}</b>
                                    </div>
                                    <div>
                                        <b class="ellipsis">{{ item.diseases }}</b>
                                    </div>
                                </el-col>
                            </div>
                        </el-row>
                    </div>
                </div>
            </el-col>
            <el-col :span="collapse == 0 ? 21 : 24">
                <el-container v-wechat-title="title" :style="{ height: screenHeight - 15 + 'px', position: 'relative' }" v-if="surgeryId > 0">
                    <el-aside width="255px" v-show="collapse == 0">
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                        <div v-if="surgery" style="padding-top: 10px;color: black;">
                                <div class="align-left font-size12">
                                    <span class="el-icon-location fg-primary font-size14" v-if="surgeryId == surgery.id"></span>
                                    申请时间：{{ ($moment(surgery.apply_time).format('YYYY/MM/DD HH:mm')) || '--' }}
                                    <span class="circle fg-red borderd" v-if="surgery.is_reoperation">再</span>
                                    <br>
                                    <span class="fg-info">【{{ surgery.surgery_status }}】：{{ ($moment(surgery.status_time).format('YYYY/MM/DD HH:mm')) || '--' }}</span>
                                </div>
                                <el-menu :unique-opened="true" class="document-list">
                                    <template v-for="item in documentList">
                                        <!-- 多例文书 -->
                                        <el-tooltip v-if="item.hasChildren && !item.is_singleton"
                                            :disabled="item.label.length < 10"
                                            :key="item.SysId"
                                            class="item"
                                            effect="light"
                                            :content="item.label"
                                            placement="right"
                                        >
                                            <el-submenu :index="item.index" :key="item.index">
                                                <div slot="title" class="align-left">
                                                    <span class="el-icon-document"></span>
                                                    <span style="width: 160px" class="ellipsis">{{ item.label }}({{ item.children.length }})</span>
                                                    <span
                                                        v-if="!currentSurgery.is_sealed"
                                                        class="btn iconfont icon-xinzeng_xian fg-primary cus-button is-circle"
                                                        @click.stop="loadNewDocumentView(item)"
                                                    ></span>
                                                </div>
                                                <template>
                                                    <el-menu-item style="position: relative;text-align: left;height: 50px;line-height: 50px;"  v-for="c in item.children" :key="c.index" :index="c.index" @click="loadDocumentPage(c)">
                                                        <div slot="title" class="align-left">
                                                            {{ c.label }}
                                                            <span
                                                                v-if="c.archiveddt == '' && !currentSurgery.is_sealed && hasMultipleDocDeleteButtonPermission"
                                                                class="btn el-icon-delete fg-danger cus-button is-circle"
                                                                @click.stop="deleteInstanceDocument(c)"
                                                            ></span>
                                                        </div>
                                                    </el-menu-item>
                                                </template>
                                            </el-submenu>
                                        </el-tooltip>
                                        <!-- 单例文书 -->
                                        <el-tooltip v-else :disabled="item.label.length < 10" :key="item.index" class="item" effect="light" :content="item.label" placement="right">
                                            <el-menu-item style="position: relative;text-align: left;height: 50px;line-height: 50px;" :key="item.index" :index="item.index" @click="loadDocumentPage(item)">
                                                <div slot="title" class="align-left">
                                                    <span class="el-icon-document"></span>
                                                    <span class="ellipsis" style="width: 135px">{{ item.label }}</span>
                                                    <span
                                                        style="width: 10px"
                                                        :class="item.children.length > 0 ? 'btn el-icon-delete fg-danger cus-button is-circle' : ''"
                                                    v-if="hasSingleDocDeleteButtonPermission && item.children && item.children[0]"
                                                        @click.stop="deleteInstanceDocument(item.children[0])"
                                                    ></span>
                                                </div>
                                            </el-menu-item>
                                        </el-tooltip>
                                    </template>
                                </el-menu>
                            </div>
                            <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
                        </el-scrollbar>
                    </el-aside>
                    <el-main class="width-p100" style="padding: 0; overflow-y: auto; overflow-x: hidden">
                        <div class="width-p100" style="position: absolute; background: whitesmoke; z-index: 2; display: flex; justify-content: flex-start; align-items: center; height: 40px">
                            <i style="cursor: pointer" :class="collapse == 1 ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="triggerCollapse()"></i>
                            <div class="inline-block" v-if="activeDoc">
                                <el-link
                                    type="primary"
                                    v-if="activeDoc.isSurportHtml && !currentSurgery.is_sealed && hasSeveButtonPermission && !activeDoc.archived"
                                    size="mini"
                                    @click="saveDocument"
                                    class="margin20 margin-none-v"
                                    v-preventReClick
                                    ><span class="iconfont icon-baocun-xian"></span>保存</el-link
                                >
                                <el-link type="primary" v-if="hasPrintButtonPermission" size="mini" @click="printDocment(activeDoc)" class="margin20 margin-none-v"
                                    ><span class="iconfont icon-dayin"></span>打印</el-link
                                >
                                <el-link type="primary" style="font-size: larger; margin-left: 5px" @click="changescalenum(0.1)"><span class="el-icon-zoom-in" title="放大"></span></el-link>
                                <el-link type="primary" style="font-size: larger; margin-left: 5px" @click="changescalenum(-0.1)"><span class="el-icon-zoom-out" title="缩小"></span></el-link>
                            </div>
                        </div>
                        <DocFrame
                            v-if="activeDoc"
                            :resetHeight="false"
                            :style="{ 'margin-top': '42px', height: screenHeight - 43 + `px`, transform: 'scale(' + this.scalenum + ')', 'transform-origin': 'center top' }"
                            ref="doc"
                            :docno="activeDoc.docno"
                            :guid="activeDoc.guid"
                            :printer_name2="activeDoc.default_printer_name"
                            :surgeryId="surgeryId"
                            :docname="activeDoc.docName"
                            :fromDt="activeDoc.fromDt"
                            :toDt="activeDoc.toDt"
                            :isSurportHtml="activeDoc.isSurportHtml"
                            :templateid="activeDoc.templateid"
                            :docbizid.sync="activeDoc.docbizid"
                            :isHide="!activeDoc.archived"
                            :caStatus="activeDoc.caStatus"
                            :isSignMultipleTimes="activeDoc.is_sign_multiple_times"
                            @afterarchive="afterArchive"
                            @afterdisarchive="afterDisarchive"
                            @changed="changed"
                            @saved="afterActiveSaved"
                            :extraParams="{ isShowSendPrintMessage: isShowSendPrintMessage }"
                        ></DocFrame>
                        <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
                    </el-main>
                    <cus-dialog
                        :title="document.title"
                        :visible.sync="document.dialogFormVisible"
                        width="80%"
                        @confirm="createDocument"
                        :overflow="false"
                    >
                        <DocFrame
                            ref="doc-new"
                            :docbizid.sync="document.docbizid"
                            :docno="document.docno"
                            :printer_name2="document.default_printer_name"
                            guid=""
                            :surgeryId="surgeryId"
                            :templateid="document.templateid"
                            :fromDt="document.fromDt"
                            :toDt="document.toDt"
                            :docname="document.docname"
                            @saved="afterDocumentSaved"
                        ></DocFrame>
                    </cus-dialog>
                </el-container>
                <p v-else class="no-surgery">暂无手术</p>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import axios from 'axios'
import pdf from '@/common/vue-pdf-4.1.0'
import { mapGetters } from 'vuex'

export default {
    name: `UnloginDocIndex`,
    components: {
        pdf
    },
    props: {},
    data() {
        return {
            docIds: this.$root.UnloginIndexDocIdsConfig && this.$root.UnloginIndexDocIdsConfig.split(`,`).map(item => parseInt(item)) || [],
            documentList: [],
            surgery: {},
            activeDoc: undefined,
            isShowSendPrintMessage: false,
            hasChanged: false,
            nextActive: undefined,
            visible: false,

            collapse: 0,
            scalenum: 1,
            pdfScalenum: parseFloat(this.$root.UnLoginPdfScaleNum || `1`),
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            token: this.$route.query.token,
            key: this.$route.query.key,
            newkey: this.$route.query.newkey,
            docid: this.$route.query.docid,
            newdocid: this.$route.query.newdocid,
            title: `文书`,
            document: {
                title: `创建文书`,
                dialogFormVisible: false,
                docno: 1,
                docname: ``,
                datetype: 2,
                templateid: undefined,
                daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                toDt: this.$moment().format(`YYYY/MM/DD HH:mm`)
            },
            surgeries: [],
            hasPrintButton: false,
            screenHeight: document.documentElement.clientHeight,
            currentSurgery: {},
            surgeryId: null,
            loading: false,
            numPages: [],
            DocumentConfig: null,
            DocArchivedList: [],
            archivedIds: [],
            para: this.$route.query.para,
            doctoken: null
        }
    },
    computed: {
        ...mapGetters([`currentUser`]),
        hasMultipleDocDeleteButtonPermission() {
            return _.find(this.permissions, { no: `Document:MultipleDocDeleteButton` }) != undefined
        },
        hasSingleDocDeleteButtonPermission() {
            return _.find(this.permissions, { no: `Document:SingleDocDeleteButton` }) != undefined
        },
        hasSeveButtonPermission() {
            return _.find(this.permissions, { no: `Document:SeveButton` }) != undefined
        },
        hasPrintButtonPermission() {
            return _.find(this.permissions, { no: `Document:PrintButton` }) != undefined
        },
        validDocumentList() {
            let r = _.reduce(
                _.groupBy(this.documentList, `surgeryId`),
                function(result, v, key) {
                    result.push({
                        surgeryId: key,
                        surgery: v[0].surgery,
                        Children: v
                    })
                    return result
                },
                []
            )
            return _.orderBy(r, `surgery.apply_time`)
        }
    },
    created() {
        this.reload()
    },
    mounted() {

    },
    methods: {
        loadPermissions() {
            return new Promise(resolve => {
                let that = this
                let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
                req.then(data => {
                    that.permissions = data
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        titleLabel(item) {
            let title = `患者:${item.patient_name} 性别:${item.sex || `--`} 年龄:${item.age || `--`} 
病例号:${item.visit_no || `--`} 
术前诊断:${item.diseases}
拟施手术:${item.surgeries}
手术医生:${item.surgeon}
手术科室:${!item.dic_section ? `` : item.dic_section}
麻醉医生:${!item.plan_anes_doctor ? `` : item.plan_anes_doctor}
申请台次:${item.sequence || ``}
申请时间:${this.$moment(item.apply_time).format(`YYYY-MM-DD HH:mm:ss`)}
计划开始时间:${this.$moment(item.plan_time).format(`YYYY-MM-DD HH:mm:ss`)}
备注:${item.his_remark || ``}
传染病:${item.infectious || ``}
麻醉类型:${item.is_local_anes_val || ``}`
            return title
        },
        reload() {
            let that = this
            this.loadToken().then(() => {
                this.$store.dispatch(`ADD_CURRENTUSER`)
                that.getConfig().then(() => {
                    that.loadPermissions().then(() => {
                        that.loadSurgeries().then(() => {
                            that.loadAssociatedOperations().then(surgeries => {
                                that.loadDocArchived(surgeries).then(info => {
                                    that.loadDocumentConfig().then(config => {
                                        that.loadDocumentList(surgeries).then(() => {
                                            if (that.docid) {
                                                that.getinfo(parseInt(that.docid), that.surgeryId)
                                            }
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        },
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getConfig() {
            return new Promise(resolve => {
                let that = this
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    that.isShowSendPrintMessage = isShow && isShow.value || false
                    resolve(isShow)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        createDocument() {
            this.$refs[`doc-new`].save()
        },
        changed(changed) {
            this.hasChanged = changed
        },
        loadToken() {
            let that = this
            if (this.newuser) {
                this.user = decodeURIComponent(window.atob(this.newuser))
            }
            if (this.newkey) {
                this.key = decodeURIComponent(window.atob(this.newkey))
            }
            if (this.newdocid) {
                this.docid = decodeURIComponent(window.atob(this.newdocid))
            }
            if (this.para) {
                let paraInfo = decodeURIComponent(window.atob(that.para))
                if (paraInfo) {
                    let paraobj = eval(
                        `(` + paraInfo + `)`
                    )
                    that.user = paraobj && paraobj.user
                    that.key = paraobj && paraobj.key
                    that.docid = paraobj && paraobj.docid
                }
            }
            return new Promise(resolve => {
                let username = this.user.split(`_`)[0]
                let password = this.user.split(`_`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    this.token = data
                    this.doctoken = this.getToken()
                    sessionStorage.setItem(`doctoken`, this.doctoken)
                    resolve(data)
                })
            })
        },
        loadSurgeries() {
            let that = this
            let req = this.myaxios.get(`api/Preoperative/Apply/GetPatientListByKey?key=${this.key}`)
            let req1 = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            return new Promise(resolve => {
                this.myaxios.all(req, req1).then(([data, data2]) => {
                    that.surgeries = data
                    that.surgeryId = (data[0] && data[0].id) || 0
                    that.currentSurgery = data[0]
                    if (data2.findIndex(item => item.permission === `Document:unlogin_PrintButton`) !== -1) {
                        that.hasPrintButton = true
                    }
                    resolve()
                }).catch(e => {
                    console.log(e)
                    that.surgeries = []
                    resolve()
                })
            })
        },
        loadAssociatedOperations(id) {
            this.surgeryId = !id ? this.surgeryId : id
            if (!this.surgeryId) {
                return Promise.resolve([])
            }
            return this.myaxios.post(`api/Intraoperative/Anaesthesia/AssociatedOperations?surgeryInfoId=${this.surgeryId}`)
        },
        loadDocArchived(surgeries) {
            let that = this
            return new Promise((resolve, reject) => {
                let req = _.map(surgeries, d => {
                    return this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetArchivedBySurgeryId?surgeryId=${d.id}`)
                })
                this.myaxios.all(...req).then(([...data]) => {
                    that.DocArchivedList = _.reduce(data, function(result, v, index) {
                        result.push(...v)
                        return result
                    }, [])
                    that.archivedIds = that.DocArchivedList.map(d => {
                        return d.docid
                    })
                    console.log(`DocArchivedList`, that.DocArchivedList)
                    resolve(that.DocArchivedList)
                })
            })
        },
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetNoDeletes`)
                req.then(DocumentConfig => {
                    that.DocumentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        loadDocumentList(surgeries) {
            let that = this
            if (!that.surgeryId && surgeries.length == 0) {
                return false
            }
            that.surgeryId = parseInt(that.surgeryId || surgeries[0].id)
            that.surgery = _.find(surgeries, { id: that.surgeryId })
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: that.surgeryId }
                })
                let req1 = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocPrintList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: that.currentSurgery.id }
                })
                this.myaxios.all(req, req1).then(([docmanagement, printlog]) => {
                    let vdoc = that.docIds // 参数定义文书ID
                    that.documentList = _.filter(_.orderBy(docmanagement.data, `PrintOrder`), d => {
                        return _.includes(vdoc, d.DocNo)
                    }).map(d => {
                        let dc = _.find(that.DocumentConfig, c => c.document_id == d.DocNo)
                        let log = _.find(printlog.data, c => c.DocID == d.DocId)
                        // 增加判断，如果配置区域打印机且为当前区域则按区域打印机进行赋值
                        let printerName = dc && dc.default_printer_name
                        // 没办法获取区域
                        // if (that.active_ward && that.active_ward.value && dc && dc.default_printer_name_by_ward) {
                        //     console.log(that.active_ward.value, dc.default_printer_name_by_ward)
                        //     let wardPrinterNames = eval(
                        //         `(` + dc.default_printer_name_by_ward + `)`
                        //     )
                        //     var wardRow = _.find(wardPrinterNames, x => x.ward == that.active_ward.value)
                        //     if (wardRow && wardRow.printer_name) {
                        //         printerName = wardRow && wardRow.printer_name
                        //     }
                        // }
                        d.index = `${d.DocNo}`
                        d.hasChildren = d.IsSurportHtml
                        d.children = []
                        d.label = d.DocName
                        d.default_printer_name = printerName || that.default_printer_name
                        d.is_singleton = dc && dc.is_singleton // 是否单例文书
                        d.is_sign_multiple_times = dc && dc.is_sign_multiple_times // 是否多次签名
                        d.printdt = log && log.DocID
                        d.archived = log && log.Archived
                        d.group_name = dc && dc.group_name
                        d.display_order = dc && dc.display_order
                        return d
                    })
                    that.documentList = _.orderBy(that.documentList, `display_order`)
                    console.log(`过滤vdoc后的documentList`)
                    console.log(that.documentList)
                    resolve(
                        _.forEach(that.documentList, d => {
                            if (d.hasChildren) {
                                that.loadInstances(d.DocNo)
                            } else {
                                if (!d.IsSurportHtml) {
                                    d.archived = _.includes(that.archivedIds, d.DocId.toString())
                                }
                            }
                        })
                    )
                    console.log(`documentList`, that.documentList)
                })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        loadInstances(docno, docbizid) {
            let that = this
            if (!that.surgeryId) {
                return false
            }
            let submenu = _.find(that.documentList, d => {
                return d.DocNo == docno
            })
            if (submenu) {
                let req = axios.get(`${that.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docid: docno, dept: `acis2020`, vid: that.surgeryId, operator: that.currentUser.dic_worker_name }
                })
                req.then(data => {
                    if (data && data.Content) {
                        let dataContent = data.Content

                        let contentInfo = _.filter(dataContent, d => {
                            return d.istemplate == `0`
                        })
                        console.log(`contentInfo`, contentInfo)
                        if (contentInfo && contentInfo.length > 0) {
                            submenu.children = contentInfo.map(d => {
                                d.index = `${d.docbizid}`
                                d.docno = submenu.DocNo
                                d.label = `${d.lastupdatedt}`
                                d.printdt = d.printdt
                                d.archiveddt = d.archiveddt
                                d.caStatus = parseInt(d.caStatus) || 0
                                d.default_printer_name = submenu.default_printer_name || that.default_printer_name
                                d.isCenterSign = d.isCenterSign
                                return d
                            })
                            if (submenu.is_singleton) {
                                submenu.isCenterSign = contentInfo[0].isCenterSign
                                submenu.archived = contentInfo[0].archiveddt && contentInfo[0].archiveddt.trim() != `` ? `archived` : ``
                            }
                        }
                        if (that.docId && submenu.DocNo == that.docId) {
                            if (submenu.children.length > 0) {
                                let nextActive = submenu.children[0]
                                nextActive && that.activeDocument(nextActive)
                            } else {
                                if (submenu.hasChildren && submenu.is_singleton) {
                                    that.loadDocumentPage(submenu)
                                }
                                if (submenu.hasChildren && !submenu.is_singleton) {
                                    that.loadNewDocIdDocPage(submenu)
                                }
                            }
                        }
                        if (docbizid) {
                            let nextActive = _.find(submenu.children, { docbizid: docbizid })
                            nextActive && that.activeDocument(nextActive)
                        }
                    } else {
                        // 没找到实例，下面会自动新开页面
                        if (that.docId && submenu.DocNo == that.docId) {
                            // this.collapse = 1 // 日历排程直接跳转到具体的文书左侧隐藏起来
                            if (submenu.children.length > 0) {
                                let nextActive = submenu.children[0]
                                nextActive && that.activeDocument(nextActive)
                            } else {
                                if (submenu.hasChildren && submenu.is_singleton) {
                                    that.loadDocumentPage(submenu)
                                }
                                if (submenu.hasChildren && !submenu.is_singleton) {
                                    that.loadNewDocIdDocPage(submenu)
                                }
                            }
                        }
                    }
                })
            }
        },
        loadDocumentPage(item) {
            console.log(`loadDocumentPage`, item)
            window.localStorage.removeItem(`docsingleton`)
            window.localStorage.setItem(`docsingleton`, item.is_singleton)
            this.isSaveing = false
            this.singleItems = []
            if (this.hasChanged) {
                this.$confirm(`当前文书已修改, 是否保存?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        this.nextActive = item
                        this.saveDocument()
                    })
                    .catch(e => {
                        this.hasChanged = false
                        this.activeDocument(item)
                    })
            } else {
                this.activeDocument(item)
            }
        },
        // 根据DocId 直接定位加载对应文书页面
        loadNewDocIdDocPage(item) {
            let that = this
            that.activeDoc = {
                title: item.DocName,
                docbizid: ``,
                docno: item.index,
                isSurportHtml: true,
                docName: this.$moment().format(`YYYYMMDDHHmmss`),
                guid: item.guid,
                datetype: item.DateArea,
                templateid: undefined,
                default_printer_name: item.default_printer_name || that.default_printer_name,
                is_sign_multiple_times: item.is_sign_multiple_times,
                templates: null
            }
            this.loadTemplates(item.DocId).then(data => {
                that.activeDoc.templates = data
                this.$nextTick(() => {
                    that.$refs[`doc`].loadDocument()
                })
            })
        },
        activeDocument(item) {
            let that = this
            if (that.isButtonDisabled) return
            that.isButtonDisabled = true
            that.loadActiveDocument(item).then(data => {
                that.activeDoc = data
                that.nextActive = undefined
                that.$nextTick(() => {
                    that.$refs.doc.loadDocument()
                    that.isButtonDisabled = false
                })
            }).catch(e => {
                that.isButtonDisabled = false
            })
        },
        loadActiveDocument(item) {
            return new Promise((resolve, reject) => {
                let that = this
                if (_.has(item, `docbizid`)) {
                    // 打开文书实列
                    let docresult = {
                        docid: item.docid,
                        docno: item.docno,
                        isSurportHtml: true,
                        docName: item.docname,
                        guid: item.guid,
                        docbizid: item.docbizid,
                        default_printer_name: item.default_printer_name || that.default_printer_name,
                        archived: item.archiveddt !== ``,
                        datetype: item.datetype,
                        templateid: item.templateid,
                        templates: item.templates,
                        daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        hasChildren: item.hasChildren,
                        is_singleton: item.is_singleton,
                        is_sign_multiple_times: item.is_sign_multiple_times,
                        caStatus: parseInt(item.caStatus) || 0
                    }
                    resolve(docresult)
                } else if (item.is_singleton) {
                    // 单例文书
                    let docname = `acis2020_${item.DocNo}_${this.surgeryId}`
                    let doced
                    if (item.children && item.children.length > 0) {
                        doced = item.children[0]
                    }
                    this.loadTemplates(item.DocId).then(data => {
                        let docresult = {
                            docid: (doced && doced.docid) || item.DocNo,
                            docno: (doced && doced.docno) || item.DocNo,
                            isSurportHtml: true,
                            docName: doced ? doced.docname : docname,
                            guid: doced ? doced.docguid : this.generateUUID(item.DocId),
                            docbizid: doced ? doced.docbizid : ``,
                            default_printer_name: item.default_printer_name || that.default_printer_name,
                            archived: doced ? doced.archiveddt : ``,
                            datetype: item.DateArea,
                            templateid: undefined,
                            templates: data,
                            daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            hasChildren: !!doced,
                            is_singleton: item.is_singleton,
                            is_sign_multiple_times: item.is_sign_multiple_times,
                            caStatus: parseInt(doced && doced.caStatus) || 0
                        }
                        resolve(docresult)
                    }).catch(e => {
                        let docresult = {
                            docid: (doced && doced.docid) || item.DocNo,
                            docno: (doced && doced.docno) || item.DocNo,
                            isSurportHtml: true,
                            docName: doced ? doced.docname : docname,
                            guid: doced ? doced.docguid : that.generateUUID(item.DocId),
                            docbizid: doced ? doced.docbizid : ``,
                            default_printer_name: item.default_printer_name || that.default_printer_name,
                            archived: doced ? doced.archiveddt : ``,
                            datetype: item.DateArea,
                            templateid: undefined,
                            templates: undefined,
                            daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            hasChildren: !!doced,
                            is_singleton: item.is_singleton,
                            is_sign_multiple_times: item.is_sign_multiple_times,
                            caStatus: parseInt(doced && doced.caStatus) || 0
                        }
                        resolve(docresult)
                    })
                } else {
                // 打开只读文书
                    let docresult = {
                        docid: item.DocNo,
                        docno: item.DocNo,
                        isSurportHtml: false,
                        archived: this.archivedIds.indexOf(item.DocNo.toString()) > -1,
                        docName: ``,
                        guid: ``,
                        docbizid: ``,
                        default_printer_name: item.default_printer_name || that.default_printer_name,
                        datetype: item.DateArea,
                        templateid: undefined,
                        daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        is_sign_multiple_times: item.is_sign_multiple_times,
                        hasChildren: false
                    }
                    resolve(docresult)
                }
            })
        },
        generateUUID(docId) {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + parseInt(docId) + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            console.log(uuid)
            return uuid
        },
        loadTemplates(docno) {
            if (!this.surgeryId) return
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryTemplateInstances`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docid: docno, deptno: ``, vid: this.surgeryId, operator: this.currentUser.dic_worker_name }
                })
                req.then(res => {
                    resolve(
                        res.Content &&
                            res.Content.map(d => {
                                return {
                                    label: d.docname,
                                    value: parseInt(d.docbizid),
                                    group: d.istemplate == `1` ? `区域模板` : `私有模板`,
                                    docguid: d.docguid
                                }
                            })
                    )
                })
            })
        },
        afterDocumentSaved() {
            let that = this
            this.document.dialogFormVisible = false
            that.loadDocumentList(that.surgeries).then(() => {
                that.loadInstances(this.document.docno, this.document.docbizid)
            })
        },
        afterArchive() {
            this.activeDoc.archived = true
            // 保存无纸化记录
            this.savePaperlessRecord(this.activeDoc.docbizid)
            // 保存互联互通CDA记录
            this.saveCDARecord(this.activeDoc.docbizid)
            this.loadInstances(this.activeDoc.docno)
        },
        afterDisarchive() {
            this.activeDoc.archived = false
            this.deletePaperlessRecord(this.activeDoc.docbizid)
            this.deleteCDARecord(this.activeDoc.docbizid)
            this.loadInstances(this.activeDoc.docno)
        },
        afterActiveSaved() {
            let that = this
            this.hasChanged = false
            that.loadDocumentList(that.surgeries).then(() => {
                that.loadInstances(this.activeDoc.docno)
            })
            if (this.nextActive) {
                this.activeDocument(this.nextActive)
            } else {
                this.$set(this.activeDoc, `hasChildren`, true)
            }
            this.isSaving = false
        },
        saveDocument() {
            if (this.activeDoc && this.activeDoc.archived) {
                return
            }
            this.isSaving = true
            this.$refs.doc.save()
            this.visible = false
        },
        deleteInstanceDocument(item) {
            let that = this
            console.log(`deleteInstanceDocument`, item)
            if (item.archiveddt && item.archiveddt != ``) {
                this.$message.error(`文书已归档，不能删除`)
                return
            }
            if (item.caStatus && item.caStatus > 0) {
                this.$message.error(`签名文书不能删除`)
                return
            }
            let docbizid = item.docbizid
            let docno = item.docno

            this.$confirm(`此操作将永久删除该记录, 是否继续`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.get_doc(`Wth/DeleteInstance`, { docbizid: docbizid, operator: that.currentUser.dic_worker_id })
                req.then(data => {
                    if (docno == that.ztdocID && item.istemplate == `0`) {
                        let req = this.myaxios.put(`/api/AcisSystem/AnalgesicRecord/DelFollowUp?surgeryId=${that.surgeryId}`)
                        req.then(data => {
                            console.log(`删除镇痛随访`)
                        })
                    }
                    that.activeDoc = undefined
                    that.loadDocumentList(that.surgeries).then(() => {
                        that.loadInstances(docno)
                    })
                    that.$message.success(`删除成功`)
                })
            })
        },
        // 多例文书新增
        loadNewDocumentView(item) {
            let that = this
            this.document.title = item.DocName
            this.document.docbizid = ``
            this.document.docno = item.index
            this.document.docname = this.$moment().format(`YYYYMMDDHHmmss`)
            this.document.datetype = item.DateArea
            this.document.templateid = undefined
            this.document.default_printer_name = item.default_printer_name || that.default_printer_name
            this.loadTemplates(item.DocId).then(data => {
                this.document.templates = data
                this.document.dialogFormVisible = true
                console.log(`loadNewDocumentView`, this.document)
                this.$nextTick(() => {
                    this.$refs[`doc-new`].loadDocument()
                })
            })
        },
        savePaperlessRecord(docbizid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }
            // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
            if (docbizid > 0) {
                // 查询归档信息
                let req1 = axios.get(`${this.$root.DOCSERVICE_BASE}/wth/QueryInstanceById`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docbizid: docbizid }
                })

                req1.then(doc => {
                    if (!doc || doc.ArchivedDt == ``) {
                        return Promise.resolve({})
                    }
                    let recData = {
                        biz_id: doc.Content.Sysid,
                        biz_surgery_info_id: doc.Content.Vid,
                        biz_type: 1, // 0麻醉单和苏醒单，1文书
                        doc_name: doc.Content.DocName,
                        file_path: `${doc.Content.Guid}.pdf`,
                        create_by: this.currentUser.username,
                        create_by_name: this.currentUser.dic_worker_name,
                        create_time: doc.Content.ArchivedDt
                    }
                    return this.myaxios.post(`api/Operation/PaperlessDocRecord/Add`, recData)
                })
            }
            return Promise.resolve({})
        },
        deletePaperlessRecord(docbizid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }

            // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
            if (docbizid > 0) {
                return this.myaxios.put(`api/Operation/PaperlessDocRecord/LogicDel?biz_id=${docbizid}&biz_type=1`)
            }
            return Promise.resolve({})
        },
        saveCDARecord(docbizid) {
            if (this.$root.OpenCDAEnabled != 1) {
                return Promise.resolve({})
            }

            // 保存互联互通记录
            if (docbizid > 0) {
                // 查询归档信息
                let req1 = axios.get(`${this.$root.DOCSERVICE_BASE}/wth/QueryInstanceById`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docbizid: docbizid }
                })

                req1.then(doc => {
                    if (!doc || doc.ArchivedDt == ``) {
                        return Promise.resolve({})
                    }
                    let recData = {
                        biz_id: doc.Content.Sysid,
                        biz_surgery_info_id: doc.Content.Vid,
                        biz_type: 1, // 0麻醉单和苏醒单，1文书
                        archive_doc_name: doc.Content.DocName,
                        archive_file_path: `${doc.Content.Guid}.pdf`,
                        create_by: this.currentUser.username,
                        create_by_name: this.currentUser.dic_worker_name,
                        create_time: doc.Content.ArchivedDt,
                        enum_doc_type: doc.Content.DocId
                    }
                    return this.myaxios.post(`api/Operation/CDARecord/Add`, recData)
                })
            }
            return Promise.resolve({})
        },
        deleteCDARecord(docbizid) {
            if (this.$root.OpenCDAEnabled != 1) {
                return Promise.resolve({})
            }

            // 删除互联互通CDA记录
            if (docbizid > 0) {
                return this.myaxios.put(`api/Operation/CDARecord/LogicDel?biz_id=${docbizid}&biz_type=1`)
            }
            return Promise.resolve({})
        },

        changescalenum(num) {
            let that = this
            let oldnum = that.document && that.scalenum || that.pdfScalenum
            var newnum = oldnum + num
            if (newnum < 1) {
                if (that.document) {
                    that.scalenum = 1
                } else {
                    that.pdfScalenum = 1
                }
                that.$message.error(`已到缩小最小值1.0倍`)
            } else if (that.document && newnum > 2) {
                that.scalenum = 2
                that.$message.error(`文书已到放大最大值2倍`)
            } else if (!that.document && newnum > 3) {
                that.pdfScalenum = 3
                that.$message.error(`pdf已到放大最大值3倍`)
            } else {
                if (that.document) {
                    that.scalenum = newnum
                } else {
                    that.pdfScalenum = newnum
                }
            }
        },
        triggerCollapse() {
            if (this.collapse == 0) {
                this.collapse = 1
            } else {
                this.collapse = 0
            }
            this.$emit(`triggerCollapse`, this.collapse)
        },
        ReloadDocument(id) {
            let that = this
            that.loadAssociatedOperations(id).then(surgeries => {
                that.loadDocArchived(surgeries).then(info => {
                    that.loadDocumentConfig().then(config => {
                        that.loadDocumentList(surgeries)
                    })
                })
            })
        },
        printDocment(c) {
            // 归档的文书不需要保存
            if (this.activeDoc.isSurportHtml) {
                this.saveDocument()
            }
            // 打印前加校验
            if (this.docProcBeforeArchive) {
                let req = this.myaxios.post(`/api/AcisSystem/DocumentConfig/BeforeArchiveCheck?surgeryId=${this.surgeryId}&docid=${c.docid}&docbizid=${c.docbizid}`)
                req.then(res => {
                    if (res && res != ``) {
                        this.$message.error(res)
                    } else {
                        this.toPrint()
                    }
                }).catch(e => {
                    console.log(e)
                })
            } else {
                this.toPrint()
            }
        },
        toPrint() {
            let that = this
            let awaitIndex = 0
            let awaitUntilEqual = () => {
                awaitIndex++
                if (this.isSaving == true && awaitIndex < 500) {
                    requestAnimationFrame(awaitUntilEqual)
                    return
                }
                let savefalg = window.localStorage.getItem(`savefalg`)
                if (savefalg == `False`) {
                    this.$message.error(`请先保存文书`)
                    return
                }
                if (this.isCanPrintDocAfterArchived && this.isCanPrintDocAfterArchived == `1`) {
                    if (!this.currentSurgery.is_sealed && !this.activeDoc.archived) {
                        this.$message.error(`请先归档`)
                        return
                    }
                }

                if (awaitIndex >= 500) {
                    this.$message.error(`打印超时，请刷新后重试~`)
                } else {
                    this.$refs.doc.print()
                    setTimeout(this.loadDocumentList(that.surgeries), 3000)
                }
            }
            awaitUntilEqual()
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.key = newUrl.query.key
            this.docid = newUrl.query.docid
            this.reload()
        }
    }
}
</script>
<style scoped lang="less" >
ul,
li {
    list-style: none;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
.surgery-patient-list:hover {
    background: rgba(144, 147, 153, 0.3);
    color: #fff;
}
.surgeryActive {
    background: var(--primary-color, #009688);
    color: #fff;
}
.pdf-page {
  /* Set A4 paper size styles */
  width: 210mm; /* A4 width */
  height: 297mm; /* A4 height */
  margin: auto;
  display: block;
}
</style>
<style lang="less">
.document-list {
    .el-submenu__icon-arrow {
        // position: absolute !important;
        left: -220px;
    }
    .btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -12px;
        font-size: 16px;
        z-index: 2;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Document/UnloginDocIndex.vue